const GRID_DIVISIONS = 8;
const GRID_LINE_POSITIONS = Array.from(
  { length: GRID_DIVISIONS - 1 },
  (_, index) => ((index + 1) * 100) / GRID_DIVISIONS
);

export default function SatelliteGridOverlay() {
  return (
    <svg
      aria-hidden='true'
      className='pointer-events-none absolute inset-0 z-10 h-full w-full'
      viewBox='0 0 100 100'
      preserveAspectRatio='none'
    >
      {GRID_LINE_POSITIONS.map((position) => (
        <g
          key={position}
          stroke='#FFFFFF'
          strokeOpacity={position === 50 ? 0.6 : 0.28}
          strokeWidth={1}
        >
          <line
            x1={position}
            y1={0}
            x2={position}
            y2={100}
            vectorEffect='non-scaling-stroke'
          />
          <line
            x1={0}
            y1={position}
            x2={100}
            y2={position}
            vectorEffect='non-scaling-stroke'
          />
        </g>
      ))}
    </svg>
  );
}
